import React from 'react';
import {connect} from 'react-redux';
import {changeInput} from "../lib/actions";
import {MAX_RING_LETTERS_PER_LINE} from "../../constants";

class Input extends React.Component {
    onChange(value) {
        if (/[^a-zA-Z0-9&]/.test(value)) {
            return;
        }

        if (value.length && value.length > MAX_RING_LETTERS_PER_LINE) {
            return;
        }

        this.props.onChange(value.toUpperCase());
    }

    render() {
        let counterClassName = 'customizer-input__count';

        if (!this.props.input || this.props.input.length === 0) {
            counterClassName += ' customizer-input__count-error';
        }

        return (
            <>
                <div className="customizer__header">
                    <p>Up to three letters side-by-side.</p>
                </div>

                <div className='customizer-input'>
                    <div className="customizer-input__line">
                        <input className='customizer-input__field' type='text' value={this.props.input} onChange={(e) => this.onChange(e.target.value)}/>
                        <div className={counterClassName}>{this.props.input ? this.props.input.length : 0}/{MAX_RING_LETTERS_PER_LINE}</div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.input,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (input) => {
            dispatch(changeInput(input));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Input);
